import { useState } from "react";
import { loginRequest } from "./api";

export function LoginForm({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const ok = await loginRequest(password);
      if (ok) {
        onSuccess();
      } else {
        setError("Contraseña incorrecta.");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "No se pudo iniciar sesión.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900"
      >
        <div>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
            Acceso privado
          </h2>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Este sitio está restringido. Ingresá la contraseña para seguir.
          </p>
        </div>
        <label className="block">
          <span className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">
            Contraseña
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-goblin-500 focus:outline-none focus:ring-2 focus:ring-goblin-500/30 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
          />
        </label>
        {error && (
          <p
            className="rounded-md bg-red-50 p-2 text-sm text-red-700 dark:bg-red-950/50 dark:text-red-300"
            role="alert"
          >
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={submitting || password.length === 0}
          className="w-full rounded-md bg-goblin-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-goblin-700 focus:outline-none focus:ring-2 focus:ring-goblin-500/50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {submitting ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
